import { useContext } from 'react';
import { Paper, List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import { TablesContext } from '../TablesContext';
import ListAltIcon from '@material-ui/icons/ListAltOutlined'
import { makeStyles } from '@material-ui/core/styles';
import { DbType, LocalTableNames } from '../../../../../helpers/Common';

const useStyles = makeStyles(theme => ({
    root: {
    },
    list: {
        height: "100%",
        overflow: "auto"
    },
    notables: {
        padding: "16px"
    }
}));

export const TableList = (props) => {
    const classes = useStyles();

    const {
        state,
        setSelectedTableId,
        isLoadingTableValues
    } = useContext(TablesContext);

    const {
        tables
    } = state;

    const getTables = () => {
        const allTables = tables
            .filter(x =>
                x.valueType === props.tableValueType &&
                (props.dbType === DbType.S4 ? x.name !== LocalTableNames.PrincipalOperationCountries : true)
            );

        if (props.dbType === DbType.ECC) {
            allTables.forEach(table => {
                if (table.name === LocalTableNames.PrincipalOperationCountries)
                    table.name = "Principal Operating Countries";
            });
        }

        // Applica il criterio di ordinamento solo ai "CustomerGroups"
        const sortedTables = allTables.sort((a, b) => {
            if (a.name.startsWith("Customer Groups") && b.name.startsWith("Customer Groups")) {
                const numA = parseInt(a.name.match(/\d+$/)?.[0] || "0", 10);
                const numB = parseInt(b.name.match(/\d+$/)?.[0] || "0", 10);
                return numA - numB;
            }

            return 0; // Mantiene l'ordine originale per le altre voci
        });

        return sortedTables;
    };
    const itemSelectHandler = (tableId) => {
        setSelectedTableId(tableId);
    };

    return (
        <>
            {
                state.tables.length > 0 ?

                    <Paper className={classes.root}>
                        <List
                            className={classes.list}>
                            {
                                getTables() &&
                                getTables().map((table, index: number): JSX.Element =>
                                    <ListItem
                                        button
                                        key={index}
                                        disabled={isLoadingTableValues}
                                        selected={state.selectedTableId === table.tableDefinitionId}
                                        onClick={() => itemSelectHandler(table.tableDefinitionId)}
                                    >
                                        <ListItemIcon>
                                            <ListAltIcon />
                                        </ListItemIcon>

                                        <ListItemText
                                            primary={table.name}
                                        />
                                    </ListItem>
                                )
                            }
                        </List>
                    </Paper> :

                    <Paper className={classes.notables}>
                        <Typography variant="h6">
                            No tables available
                        </Typography>
                        <Typography variant="body1" style={{ marginTop: 8 }}>
                            There's no tables avaiable at this time
                        </Typography>
                    </Paper>
            }
        </>
    );
};